var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('b-row',[_c('b-col',{staticClass:"text-center"},[_c('img',{attrs:{"height":"200px","src":require("../../assets/images/logo.png")}})])],1),_c('b-row',[_c('b-col',{staticClass:"text-center mt-2"},[_c('img',{attrs:{"height":"50px","src":require("../../assets/images/title.png")}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }